const IsFailingCreationAuthorizedUsersGroupExecution = "IsFailingCreationAuthorizedUsersGroupExecution";
const IsFailingManagementAuthorizedUsersGroupExecution = "IsFailingManagementAuthorizedUsersGroupExecution";
const IsFailingQuotaAuthorizedUsersGroupExecution = "IsFailingQuotaAuthorizedUsersGroupExecution";

export default Object.freeze({
    [IsFailingCreationAuthorizedUsersGroupExecution]: 0,
    [IsFailingManagementAuthorizedUsersGroupExecution]: 1,
    [IsFailingQuotaAuthorizedUsersGroupExecution]: 2,
});

export const ConfigurationSetWarningCodeNames = Object.freeze({
    0: IsFailingCreationAuthorizedUsersGroupExecution,
    1: IsFailingManagementAuthorizedUsersGroupExecution,
    2: IsFailingQuotaAuthorizedUsersGroupExecution,
});
